import { motion } from "framer-motion";
import { METRICS } from "@/lib/content";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";

export default function Metrics() {
    return (
        <section className="relative border-y border-white/10 bg-navy-900" data-testid="metrics">
            <StaggerGroup className="mx-auto grid max-w-7xl grid-cols-2 md:grid-cols-4">
                {METRICS.map((m, i) => (
                    <StaggerItem
                        key={m.label}
                        className={`px-6 py-10 md:px-10 md:py-14 ${
                            i !== METRICS.length - 1
                                ? "md:border-r border-white/10"
                                : ""
                        } ${i < 2 ? "border-b md:border-b-0 border-white/10" : ""} ${
                            i % 2 === 0 ? "border-r md:border-r border-white/10" : ""
                        }`}
                    >
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            {m.label}
                        </p>
                        <p className="mt-4 font-display text-3xl md:text-5xl font-light text-white">
                            {m.value}
                        </p>
                        <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-white/40">
                            {m.sub}
                        </p>
                    </StaggerItem>
                ))}
            </StaggerGroup>

            {/* Prominent 12-month goal banner */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="relative overflow-hidden border-t border-gold/25 bg-gold/[0.05]"
                data-testid="goal-banner"
            >
                <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-6 py-8 md:flex-row md:items-center md:justify-between md:px-12">
                    <div className="flex items-center gap-4">
                        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Phase 1 · Near-Term Milestone
                        </span>
                    </div>
                    <p className="font-display text-2xl md:text-3xl font-light text-white">
                        <span className="text-gold">$2M</span> in revenue on the{" "}
                        <span className="text-gold">$88</span> guided plan
                    </p>
                </div>
                <div className="hairline-gold absolute bottom-0 left-0 h-px w-full" />
            </motion.div>
        </section>
    );
}
